import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`For Next.js, we recommend following the `}<a parentName="p" {...{
          "href": "/docs/integrate/next-js"
        }}>{`Next.js integration guide`}</a>{` instead.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Install `}<a parentName="li" {...{
          "href": "https://github.com/posthog/posthog-js"
        }}>{`posthog-js`}</a>{` using your package manager`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`yarn add posthog-js
# or
npm install --save posthog-js
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Add your environment variables to your `}<inlineCode parentName="li">{`.env.local`}</inlineCode>{` file and to your hosting provider (e.g. Vercel, Netlify, AWS). You can find your project API key in the PostHog app under Project Settings > API Keys.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-shell",
        "metastring": "file=.env.local",
        "file": ".env.local"
      }}>{`REACT_APP_PUBLIC_POSTHOG_KEY=<ph_project_api_key>
REACT_APP_PUBLIC_POSTHOG_HOST=<ph_instance_address>
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Integrate PostHog at the root of your app (`}<inlineCode parentName="li">{`src/index.js`}</inlineCode>{` for the default `}<inlineCode parentName="li">{`create-react-app`}</inlineCode>{`).`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { PostHogProvider} from 'posthog-js/react'

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      